import { render } from "./ShareNote.vue?vue&type=template&id=dca40de8&scoped=true"
import script from "./ShareNote.vue?vue&type=script&lang=js"
export * from "./ShareNote.vue?vue&type=script&lang=js"

import "./ShareNote.vue?vue&type=style&index=0&id=dca40de8&scoped=true&lang=css"

import exportComponent from "G:\\Graduation project\\notemd\\FrontEnd\\notemd-web\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_29d074f7dbbfd97370df878da6275bc8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca40de8"]])

export default __exports__